module.exports = __webpack_public_path__ + "static/media/crisis-situations@3x.246336a1.png";